import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { MyauthService } from '../services/myauth.service';

@Injectable({
  providedIn: 'root'
})
export class InnerpagesGuard implements CanActivate {

  constructor(private myauth: MyauthService, private router: Router){

  }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
      if(!this.myauth.isLoggedIn) {
        alert("You need to Sign-In for this action!");
        this.router.navigate(['signin']);
      }
    return true;
  }
  
}
